<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
      ]"
    />

    <table-inspect-merge
      class="mt-4"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      v-model="form.inspectList_1"
      title="1. 법적준수여부(산업안전보건법 관련)"
      table-header-title="법적의무사항"
      :table-header-note="[{ text: '비고', width: '300' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '100' },
        { text: '미흡', value: 'No', width: '100' },
        { text: '해당없음', value: 'N/A', width: '100' },
      ]"
    >
      <template #customContent="{ trData }">
        <div class="flex w-full" style="align-items: center;">
          <p v-if="isPrint">{{ trData.기타사항 }}</p>
          <ml-input v-else v-model="trData.기타사항" class="w-full" />
        </div>
      </template>
    </table-inspect-merge>

    <table-inspect-merge
      class="mt-4"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      v-model="form.inspectList_2"
      title="2. 체크리스트"
      table-header-title="점검항목"
      :table-header-note="[{ text: '비고', width: '300' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '100' },
        { text: '미흡', value: 'No', width: '100' },
        { text: '해당없음', value: 'N/A', width: '100' },
      ]"
    >
      <template #customContent="{ trData }">
        <div class="flex w-full" style="align-items: center;">
          <p v-if="isPrint">{{ trData.기타사항 }}</p>
          <ml-input v-else v-model="trData.기타사항" class="w-full" />
        </div>
      </template>
    </table-inspect-merge>
    <p class="mt-4" style="font-weight: 700; font-size: 15px; color: #3c3c3c;">
      ※ 합동안전보건 점검반(구성: 도급인 및 수급인 사업주, 도급인 및 수급인 근로자 각1명)</p>

    <div class="flex mt-4 gap-4">
      <table-custom
        class="flex-1"
        :board="board"
        :is-print="isPrint"
        title="도급인"
        :tableData="[
        { id: '소속명', title: '소속명', type: 'text', placeholder: '내용' },
        { id: '이름', title: '이름', type: 'text', placeholder: '내용' },
        { id: '서명', title: '서명', type: 'sign', placeholder: '내용' },
      ]"
        v-model="form.도급인"
        thema="label"
      />

      <table-custom
        class="flex-1"
        :board="board"
        :is-print="isPrint"
        title="수급인"
        :tableData="[
        { id: '소속명', title: '소속명', type: 'text', placeholder: '내용' },
        { id: '이름', title: '이름', type: 'text', placeholder: '내용' },
        { id: '서명', title: '서명', type: 'sign', placeholder: '내용' },
      ]"
        v-model="form.수급인"
        thema="label"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="점검 사진" placeholder="사진내용" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "@/views/boards/single-page/1077/inspectData";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    SignField,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectList_1: inspectData.inspectTable_1,
        inspectList_2: inspectData.inspectTable_2,

        도급인: [],
        수급인: [],
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
